import SelfServiceUserRegistration from './SelfServiceUserRegistration';

export default SelfServiceUserRegistration;
